// extracted by mini-css-extract-plugin
module.exports = {"container":"_3MwZ9jhCsqeCrJqjOCipHg","squares":"_2mrnsWgEoA_zlcxTIxXhNp","countCard":"_13jPdoXBykHnTRxl-rlYJ8","paragraph":"_2QHE2d0HfLrDCEbRuazVk5"};